/* eslint-disable */

/* This file is generated, don't modify directly. See README.md in Icon folder */
import React from 'react';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
type Props = Omit<SvgIconProps, 'viewBox'>;

function User2(props: Props) {
    const newProps = { ...props, viewBox: '0 0 32 32' };
    return React.createElement(
        SvgIcon,
        newProps,
        <path
            d="M23.372 17.867c2.993 0 7.636 5.211 8.454 9.29.818 4.08-1.426 4.843-3.06 4.843H2.997C1.452 32-.596 30.866.164 27.158c.76-3.708 6.6-9.29 9.224-9.29 2.624 0 3.461 1.382 7.158 1.382 3.697 0 3.832-1.383 6.826-1.383zm-1.47-15.362c2.016 2.023 4.087 7.433.09 11.487-3.999 4.054-9.3 2.506-11.622.167-2.321-2.338-4.122-7.43.013-11.743 4.134-4.313 9.503-1.934 11.52.089z"
            fill="currentColor"
            fillRule="evenodd"
        />
    );
}

export default User2;
